export default __webpack_public_path__ + "static/media/paperclip.b67f78f0.svg";